import Swal from "sweetalert2";

window.addEventListener("load", function () {
    window.Swal = Swal;
});
